export type VerificationGateDecision = "loading" | "error" | "allow" | "block";
export type ExpenseSetupGateDecision = "loading" | "allow" | "block";

interface VerificationGateInput {
  agencyLoading: boolean;
  setupLoading: boolean;
  agencyError: boolean;
  setupError: boolean;
  agency?: { isOperator: boolean };
  setup?: { previewAllowed: boolean };
}

/** Gross analytics unlock when the server confirms account basics plus a
 * proven order source. Full verification remains a separate expense-mode gate. */
export function getVerificationGateDecision(
  input: VerificationGateInput,
): VerificationGateDecision {
  if (input.agencyLoading || input.setupLoading) return "loading";
  if (input.agencyError || input.setupError || !input.agency || !input.setup) return "error";
  if (input.agency.isOperator || input.setup.previewAllowed) return "allow";
  return "block";
}

interface ExpenseSetupGateInput {
  agencyLoading: boolean;
  capabilitiesLoading: boolean;
  agencyError: boolean;
  capabilitiesError: boolean;
  agency?: { isOperator: boolean };
  capabilities?: { financialBasis?: "revenue" | "profit" };
}

/** Expense setup is a second-pass surface. It never flashes open while role or
 * readiness is unknown, and ordinary clients cannot reach it in revenue mode
 * through an old bookmark. */
export function getExpenseSetupGateDecision(
  input: ExpenseSetupGateInput,
): ExpenseSetupGateDecision {
  if (input.agencyLoading || input.capabilitiesLoading) return "loading";
  if (input.agencyError || input.capabilitiesError || !input.agency || !input.capabilities) return "block";
  if (input.agency.isOperator || input.capabilities.financialBasis === "profit") return "allow";
  return "block";
}
